import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

import '@/assets/styles/app.scss'

const WP_SITE = 'cropnutrition.local';
const APP_PATH = '/app/plugins/mos-cn-vue-wp-plugin/dist';
const WP_PATH = '/wp-content/plugins/mos-cn-vue-wp-plugin/dist';

if (window.location.hostname === 'localhost') {
  window.host_domain = '';
} else if (window.location.hostname === WP_SITE) {
  window.host_domain = window.location.protocol + '//' + WP_SITE + APP_PATH;
} else {
  window.host_domain = window.location.protocol + '//' + window.location.hostname + WP_PATH;
}

const app = createApp(App)

app.use(router).mount('#app');
